import { createApp } from 'vue'

const loadVersion = () => {
  switch(process.env.VUE_APP_MODE) {
    case 'user':
    default:
      return import(/* webpackChunkName: "user-version" */ './components/User/main')
  }
}

loadVersion()
  .then(module => {
    const { createVersionApp } = module
    const app = createVersionApp(createApp)
    
    app.config.errorHandler = (err) => {
      console.error('全局错误:', err)
    }
    
    app.mount('#app')
  })
  .catch(error => {
    console.error('版本加载失败:', error)
    document.getElementById('app').innerHTML = '系统加载失败，请刷新重试'
  })